// extracted by mini-css-extract-plugin
export var cancelButton = "_p1-5";
export var content = "_p1-3";
export var createButton = "_p1-6";
export var drawerContainer = "_p1-0";
export var footer = "_p1-2";
export var header = "_p1-1";
export var orderFormColumn = "_p1-4";